import React from "react";
import Header from "../components/Header";
import Resume from "../components/Resume";
import Footer from "../components/Footer";

const IndexPage = () => (
  <div>
    <Header />
    <Resume />
    <Footer />
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js